const getPromptText = (isRequired: boolean, isEncouraged: boolean) => {
  if (isRequired) return 'Required';
  if (isEncouraged) return 'Encouraged';
  return '';
};

export { getPromptText };
